import React from 'react';
import { UserPlus, Building2, LogOut, Calculator, Moon, Sun } from 'lucide-react';
import { Button } from '../../ui/Button';
import { useNavigate } from 'react-router-dom';
import { AdminButton } from './AdminButton';
import { useAuth } from '../../../contexts/AuthContext';
import { useTheme } from '../../../contexts/ThemeContext';

export const UserActions: React.FC = () => {
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const { theme, toggleTheme } = useTheme();
  const isAdmin = user?.role === 'admin';

  const handleAddClient = () => {
    navigate('/ajouter/client');
  };

  const handleAddProperty = () => {
    navigate('/ajouter/vente');
  };

  const handleLogout = () => {
    if (window.confirm('Êtes-vous sûr de vouloir vous déconnecter ?')) {
      logout();
    }
  };
  return (
    <div className="flex items-center gap-4">
      {isAdmin && <AdminButton />}
      <Button
        className="flex items-center gap-1.5 sm:gap-2 text-sm px-2 py-1.5 sm:px-3 sm:py-2"
        onClick={handleAddClient}
      >
        <UserPlus className="h-4 w-4 sm:h-5 sm:w-5" />
        <span className="hidden md:inline">Ajouter un client</span>
      </Button>
      <Button
        className="flex items-center gap-1.5 sm:gap-2 text-sm px-2 py-1.5 sm:px-3 sm:py-2"
        onClick={handleAddProperty}
      >
        <Building2 className="h-4 w-4 sm:h-5 sm:w-5" />
        <span className="hidden md:inline">Ajouter un bien</span>
      </Button>
      
      <Button
        variant="ghost"
        size="icon"
        className="h-9 w-9 hidden md:flex"
        onClick={toggleTheme}
      >
        {theme === 'light' ? (
          <Moon className="h-5 w-5" />
        ) : (
          <Sun className="h-5 w-5" />
        )}
        <span className="sr-only">Toggle theme</span>
      </Button>
      
      <Button
        variant="ghost"
        size="icon"
        onClick={handleLogout}
        className="h-9 w-9 hidden md:flex"
        title="Déconnexion"
      >
        <LogOut className="h-4 w-4" />
      </Button>
    </div>
  );
};